import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import Amplitude from "@Shared/@Utils/amplitude";
import { computed, defineComponent, ref } from "@vue/composition-api";
import ProfileAvatar from "@Shared/components/general/profile-avatar.vue";
import * as AccountGetters from "@Broker/@Modules/main/store/account/account-getters";
import * as AgentGetters from "@Broker/@Modules/agents/store/agent-getters";
import * as AccountPlanActions from "@Broker/@Modules/account-plan/store/account-plan-actions";
import * as AccountPlanGetters from "@Broker/@Modules/account-plan/store/account-plan-getters";
import ManageSubscriptionsModal from "./manage-subscriptions-modal.vue";
import NotificationPopover from "@Shared/components/general/notification-popover.vue";
import { isEmpty } from "lodash";
import { useAccountStoreGetters } from "@Broker/@Modules/main/store/account/account-helpers";
import { useAccountPlanStoreActions, useAccountPlanStoreGetters } from "../../store/account-plan-helpers";
import { useAgentStoreGetters } from "@Broker/@Modules/agents/store/agent-helpers";
import CancelPlanConfirmation from "./modals/cancel-plan-confirmation.vue";
import { delay } from "@Shared/@Utils/utils";
import { useI18n } from "vue-i18n-composable";
export default defineComponent({
  name: "SubscriptionsContainer",
  components: {
    ProfileAvatar,
    ManageSubscriptionsModal,
    NotificationPopover,
    CancelPlanConfirmation
  },
  setup() {
    const {
      t,
      tc
    } = useI18n();
    const {
      CURRENT_USER_USERNAME
    } = useAccountStoreGetters([AccountGetters.CURRENT_USER_USERNAME]);
    const {
      GET_AGENT
    } = useAgentStoreGetters([AgentGetters.GET_AGENT]);
    const {
      CANCEL_SUBSCRIPTIONS,
      LOAD_ACCOUNT_PLAN_DETAILS
    } = useAccountPlanStoreActions([AccountPlanActions.CANCEL_SUBSCRIPTIONS, AccountPlanActions.LOAD_ACCOUNT_PLAN_DETAILS]);
    const {
      IS_CURRENT_USER_PAYER,
      SUBSCRIPTIONS,
      HAS_CURRENT_USER_ACTIVE_SUBSCRIPTIONS,
      HAS_CURRENT_USER_PAYMENT_METHODS,
      IS_CURRENT_USER_SUBSCRIBED,
      HAS_PAYMENT_ERROR
    } = useAccountPlanStoreGetters([AccountPlanGetters.IS_CURRENT_USER_PAYER, AccountPlanGetters.SUBSCRIPTIONS, AccountPlanGetters.HAS_CURRENT_USER_ACTIVE_SUBSCRIPTIONS, AccountPlanGetters.HAS_CURRENT_USER_PAYMENT_METHODS, AccountPlanGetters.IS_CURRENT_USER_SUBSCRIBED, AccountPlanGetters.HAS_PAYMENT_ERROR]);
    const manageSubscriptionModal = ref();
    const currentMode = ref("add");
    const canceling = ref(false);
    const subscriptionToCancel = ref({
      username: "",
      agentName: ""
    });
    const search = ref("");
    const showCancelModal = ref(false);
    const options = computed(() => ({
      filterable: false,
      sortable: ["plan", "willBeRenewed", "email"],
      columns: ["agent", "plan", "willBeRenewed", "email"],
      sortIcon: {
        base: "fa",
        up: "fa-sort-up",
        down: "fa-sort-down",
        is: "fa-sort"
      },
      headings: {
        agent: tc("global.doorr.agent", 1),
        plan: t("account.accountPlan.subscriptionsTab.accountPlan"),
        willBeRenewed: t("account.accountPlan.subscriptionsTab.willBeRenewed"),
        email: tc("global.words.email", 1)
      },
      orderBy: {
        ascending: false,
        column: "willBeRenewed"
      },
      columnsClasses: {
        agent: "w-30",
        plan: "w-20",
        willBeRenewed: "w-20",
        email: "w-30 text-wrap-all"
      },
      skin: "table table-hover",
      perPage: 999999,
      texts: {
        noResults: t("account.accountPlan.perks.emptySubscriptionsMessage")
      }
    }));
    const userHasSubscriptions = computed(() => !isEmpty(SUBSCRIPTIONS.value) && IS_CURRENT_USER_SUBSCRIBED.value && HAS_CURRENT_USER_ACTIVE_SUBSCRIPTIONS.value);
    const addSubscriptionsTooltipText = computed(() => {
      if (HAS_PAYMENT_ERROR.value) return t("account.accountPlan.planModals.paymentFailed.title");
      return !HAS_CURRENT_USER_PAYMENT_METHODS.value ? t("account.accountPlan.paymentNeededTooltip") : t("account.accountPlan.subscriptionsTab.addSubscriptionNoPayer");
    });
    const disableAddSubscription = computed(() => !(HAS_CURRENT_USER_PAYMENT_METHODS.value && IS_CURRENT_USER_SUBSCRIBED.value && IS_CURRENT_USER_PAYER.value));
    const allowCancel = ({
      username,
      isCancellable
    }) => username !== CURRENT_USER_USERNAME.value && isCancellable;
    const filteredSubscriptions = computed(() => {
      var _SUBSCRIPTIONS$value;
      return (_SUBSCRIPTIONS$value = SUBSCRIPTIONS.value) == null ? void 0 : _filterInstanceProperty(_SUBSCRIPTIONS$value).call(_SUBSCRIPTIONS$value, ({
        username
      }) => {
        var _context;
        const {
          givenName,
          familyName,
          email
        } = GET_AGENT.value(username);
        const stringToEvaluate = `${givenName} ${familyName} ${email}`;
        return _includesInstanceProperty(_context = stringToEvaluate.toLowerCase()).call(_context, search.value.toLowerCase());
      });
    });
    const showManageSubscriptionModal = mode => {
      var _manageSubscriptionMo;
      currentMode.value = mode;
      (_manageSubscriptionMo = manageSubscriptionModal.value) == null ? void 0 : _manageSubscriptionMo.openModal();
    };
    const cancelSingleSubscription = async () => {
      const payload = {
        accountsToCancel: [subscriptionToCancel.value.username]
      };
      canceling.value = true;
      await CANCEL_SUBSCRIPTIONS(payload);
      await delay(8000);
      LOAD_ACCOUNT_PLAN_DETAILS();
      canceling.value = false;
      showCancelModal.value = false;
      subscriptionToCancel.value = {
        username: "",
        agentName: ""
      };
      Amplitude.logEvent("Account Plan - Cancel Subscription Attempt Finished", _objectSpread({
        component: "subscriptions-container"
      }, payload));
    };
    const handleShowCancelModal = (username, agentName) => {
      showCancelModal.value = true;
      subscriptionToCancel.value = {
        username,
        agentName
      };
      Amplitude.logEvent(`Account Plan - Cancel Subscription Modal Opened`, {
        component: "subscriptions-container"
      });
    };
    const willBeRenewed = ({
      isCurrentUser,
      willBeRenewed
    }) => isCurrentUser ? IS_CURRENT_USER_SUBSCRIBED.value : willBeRenewed;
    return {
      search,
      canceling,
      CURRENT_USER_USERNAME,
      IS_CURRENT_USER_PAYER,
      IS_CURRENT_USER_SUBSCRIBED,
      options,
      filteredSubscriptions,
      manageSubscriptionModal,
      currentMode,
      userHasSubscriptions,
      addSubscriptionsTooltipText,
      disableAddSubscription,
      showCancelModal,
      subscriptionToCancel,
      GET_AGENT,
      allowCancel,
      showManageSubscriptionModal,
      cancelSingleSubscription,
      handleShowCancelModal,
      willBeRenewed
    };
  }
});